import axios from 'axios';
import { getToken } from './auth';

import { API_URL } from './config';

const withAuth = () => ({
  headers: { Authorization: `Bearer ${getToken()}` },
  withCredentials: true,
});

export const getScaleStatus = async (branchId, cashRegisterId) =>
  (await axios.get(
    `${API_URL}/branch/${branchId}/cash-registers/${cashRegisterId}/scale/status`,
    withAuth()
  )).data;

export const createScalePairingCode = async (branchId, cashRegisterId) =>
  (await axios.post(
    `${API_URL}/branch/${branchId}/cash-registers/${cashRegisterId}/scale/pairing-codes`,
    {},
    withAuth()
  )).data;

export const getScaleConsumerToken = async (branchId, cashRegisterId) =>
  (await axios.post(
    `${API_URL}/branch/${branchId}/cash-registers/${cashRegisterId}/scale/consumer-token`,
    {},
    withAuth()
  )).data;

export const deleteScaleBinding = async (branchId, cashRegisterId) =>
  (await axios.delete(
    `${API_URL}/branch/${branchId}/cash-registers/${cashRegisterId}/scale/binding`,
    withAuth()
  )).data;

export const resolveScaleWebsocketUrl = (path, token) => {
  const url = new URL(path, API_URL);
  url.protocol = url.protocol === 'https:' ? 'wss:' : 'ws:';
  if (token) {
    url.searchParams.set('token', token);
  }
  return url.toString();
};

